import Chart from '../../../components/Chart/index';
import * as Styled from '../Dashboard.styles';
import { theme } from '../../../styles/theme';
import * as dayjs from 'dayjs';
import { Typography } from '@material-ui/core';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { transactionsFetchAction } from '../../../store/fetchActions/transactionsActions';
import { listNewUsersFetchAction } from '../../../store/fetchActions/listUsersActions';

export default function ChartContainer() {
  const { mainColor, secondaryColor } = theme.colors;

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(transactionsFetchAction());
    dispatch(listNewUsersFetchAction());
  }, []);

  const {
    transactionsData: { TRANSACOES },
  } = useSelector((state) => state.transactions);

  const { dataListNewUsers } = useSelector((state) => state.listUsers);

  const defaultChartData = [0, 0, 0, 0, 0, 0, 0];

  const formatDates = (dates) => {
    var formattedDataArray = [];
    formattedDataArray = dates.map((date) => {
      return dayjs(date).format('DD/MM/YYYY');
    });

    return formattedDataArray;
  };
  let dates = TRANSACOES ? Object.keys(TRANSACOES.DEBITO).reverse() : [];
  let formattedDates = formatDates(dates);
  let debitData = TRANSACOES
    ? Object.values(TRANSACOES.DEBITO).reverse()
    : defaultChartData;
  let creditData = TRANSACOES
    ? Object.values(TRANSACOES.CREDITO).reverse()
    : defaultChartData;
  let newUserData = dataListNewUsers
    ? Object.values(dataListNewUsers).reverse()
    : defaultChartData;

  const chartData = {
    title: 'Transações',
    secondaryTitle: 'Últimos 7 dias',
    labels: formattedDates,
    datasets: [
      {
        label: 'Débito',
        backgroundColor: `${secondaryColor}`,
        data: debitData,
        barPercentage: 0.6,
      },
      {
        label: 'Crédito',
        backgroundColor: `${mainColor}`,
        data: creditData,
        barPercentage: 0.6,
      },
    ],
  };
  const secondChartData = {
    title: 'Entrada de Clientes',
    secondaryTitle: 'Últimos 7 dias',
    labels: formattedDates,
    datasets: [
      {
        label: 'Entradas Diárias',
        backgroundColor: `${mainColor}`,
        data: newUserData,
        barPercentage: 0.3,
      },
    ],
  };

  return (
    <Styled.ChartContainer>
      <Styled.ChartGrid>
        <Styled.ChartElement>
          <Styled.Header>
            <Typography variant="h5">{chartData.title}</Typography>
            <Typography variant="h6">{chartData.secondaryTitle}</Typography>
          </Styled.Header>
          <Chart
            title={chartData.subtitle}
            labels={chartData.labels}
            data={chartData.datasets}
            containerHeight={'24.792vw'}
          ></Chart>{' '}
        </Styled.ChartElement>
        <Styled.ChartElement>
          <Styled.Header>
            <Typography variant="h5">{secondChartData.title}</Typography>
            <Typography variant="h6">
              {secondChartData.secondaryTitle}
            </Typography>
          </Styled.Header>
          <Chart
            title={secondChartData.subtitle}
            labels={secondChartData.labels}
            data={secondChartData.datasets}
            moneyFormat={false}
            containerHeight={'24.792vw'}
          ></Chart>
        </Styled.ChartElement>
        <Styled.LargeChart>
          <Styled.Header>
            <Typography variant="h5">{'Movimentações do Dia'}</Typography>
            <Typography variant="h6">{chartData.secondaryTitle}</Typography>
          </Styled.Header>
          <Chart
            title={chartData.subtitle}
            labels={chartData.labels}
            data={chartData.datasets}
            moneyFormat={false}
            containerHeight={'24.792vw'}
          ></Chart>{' '}
        </Styled.LargeChart>
      </Styled.ChartGrid>
    </Styled.ChartContainer>
  );
}
